<template>
  <div class="footer">
    <div class="wp">
      @copywriter 2025
    </div>
  </div>
</template>

<script setup>

</script>


<style scoped>
.footer{
  height: 60px;
  line-height: 60px;
  background: #333;
  color: #FFFFFF;
  text-align: center;
}
</style>